import React from "react";

const BannerGradient = () => {
  return (
    <>
      {/* First radial glow - bottom left */}
      <div
        style={{
          position: "absolute",
          width: "300px",
          height: "300px",
          bottom: "40%",
          left: "40%",
          background: "radial-gradient(circle, #5442b9 0%, transparent 60%)",
          filter: "blur(60px)",
          zIndex: 0,
        }}
      />

      {/* Second radial glow - mid left */}
      <div
        style={{
          position: "absolute",
          width: "300px",
          height: "300px",
          bottom: "25%",
          left: "25%",
          background: "radial-gradient(circle, #5442b9 0%, transparent 60%)",
          filter: "blur(60px)",
          zIndex: 0,
        }}
      />
    </>
  );
};

export default BannerGradient;
